import { ToastContext } from 'app/components/Context/ToastContext';
import { useContext } from 'react';
import { useMutation } from 'react-query';
import { PostGenerateOTP } from 'services/apiServices';
import { Errors, TPostGenerateOTPResult } from 'types/ApiServicesTypes';

export const usePostGenerateOTP = () => {
  const { showAlert } = useContext(ToastContext);
  const mutation = useMutation<
    TPostGenerateOTPResult,
    Errors,
    Pick<{ ubid: number }, 'ubid'>
  >('PostGenerateOTP', value =>
    PostGenerateOTP(value.ubid)
      .then(res => {
        if (!res || res.errors)
          showAlert!(
            res.errors ? res.errors : 'Something went wrong. Please try again.',
          );
        return res;
      })
      .catch(err => {
        showAlert!(err.message as string);
        return err;
      }),
  );

  if (mutation.isError && mutation.error) {
    showAlert!(mutation.error.message);
  }

  return mutation;
};
